@if (isMobile()) {
  <div
    display="dynamic"
    placement="bottom-start"
    #d="ngbDropdown"
    [autoClose]="'outside'"
    ngbDropdown>
    <button
      class="filter-trigger-btn"
      ngbDropdownToggle>
      @if (hasActiveFilters()) {
        <span class="filter-badge">
          <span class="visually-hidden">Filter applied</span>
        </span>
      }
      <i class="iconoir-search"></i>
    </button>
    <div
      class="border-0 search-dropdown"
      ngbDropdownMenu>
      @if (d.isOpen()) {
        <div class="card shadow border-opacity-25 dropdown-enter">
          <div class="card-body">
            <div class="fw-semibold mb-2">Search</div>
            <ng-container [ngTemplateOutlet]="searchBar"></ng-container>
          </div>
        </div>
      }
    </div>
  </div>
} @else {
  <ng-container [ngTemplateOutlet]="searchBar"></ng-container>
}
<ng-template #searchBar>
  <div class="row g-3 flex-lg-nowrap">
    <div [ngClass]="isMobile() ? 'col-auto' : 'col-auto'">
      <div class="drop-down-search-wrap">
        <ng-select
          [class]="'ng-select-sm'"
          [clearable]="false"
          [(ngModel)]="selectedSearch"
          [placeholder]="'Select search option'"
          (change)="onSelectOption()"
          (keydown)="onSelectOption()"
          (click)="searchField.focus()"
          [searchable]="false">
          @for (item of searchOptions; track item.value) {
            <ng-option [value]="item.value">
              {{ item.option }}
            </ng-option>
          }
        </ng-select>
        <label
          for="searchField"
          class="d-none"
          >Search</label
        >
        <input
          id="searchField"
          #searchField
          type="text"
          [(ngModel)]="value"
          (keydown.enter)="onSearch()"
          class="form-control search-field"
          [ngClass]="selectedSearch ? '' : 'invisible'"
          placeholder="Search {{ selectedSearchLabel }}" />
        @if (value.length) {
          <button
            class="enter-btn"
            (click)="onSearch()"
            type="button">
            &crarr;
          </button>
        }
      </div>
    </div>
    @if (hasActiveFilters()) {
      <div class="col">
        @for (option of searchOptions; track option.value) {
          <div
            class="search-chip-wrap"
            [ngClass]="'max-chips-' + searchOptions.length"
            title="{{ queryParams.get(option.value) }}">
            @if (queryParams.get(option.value)) {
              <div class="search-chip">
                <div class="search-chip__text">
                  <div class="label">{{ option.option }}</div>
                  <div class="value">{{ queryParams.get(option.value) }}</div>
                </div>
                <button
                  class="btn search-chip__btn btn-reset"
                  type="button"
                  (click)="onDelete(option.value)">
                  <i class="iconoir-xmark"></i>
                </button>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
</ng-template>
